export const BLOTTER_DAYS_COLLECTION = "POLICE_BLOTTER_DAYS";
export const BLOTTER_META_COLLECTION = "POLICE_BLOTTER_META";
export const BLOTTER_META_ID = "index";

export function shiftDay(day, amount) {
  const date = new Date(`${day}T00:00:00Z`); date.setUTCDate(date.getUTCDate() + amount); return date.toISOString().slice(0, 10);
}
export function daysInclusive(fromDay, throughDay, maximum = 31) {
  const days = [];
  for (let day = fromDay; day <= throughDay && days.length < maximum; day = shiftDay(day, 1)) days.push(day);
  return days;
}
function value(dictionary, id) { return id < 0 ? null : dictionary[id]; }
export function decodeBlotterDays(documents) {
  return documents.flatMap(document => document.cfsNumbers.map((cfsNumber, index) => ({
    day: document.day,
    cfsNumber: cfsNumber || null,
    receivedDateTime: `${document.day}T${document.receivedTimes[index]}`,
    streetName: value(document.streets, document.streetIds[index]),
    streetType: value(document.streetTypes, document.streetTypeIds[index]),
    callType: value(document.callTypes, document.callTypeIds[index]),
  })));
}
